import "./About.module.css";
import Header from "@/reusable_sections/Header";
import OurStory from "./sections/OurStory";
import HowWeRank from "./sections/HowWeRank";
import MeetTheTeam from "./sections/MeetTheTeam";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <OurStory />
      <HowWeRank />
      <MeetTheTeam />
      <Footer />
    </div>;
}